export default __webpack_public_path__ + "static/media/tick.2a155b26.svg";